import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavigateToPageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2561 7.96342V15.4668C16.2561 16.5714 15.3607 17.4668 14.2561 17.4668H2.5C1.39543 17.4668 0.5 16.5714 0.5 15.4668V3.7177C0.5 2.61041 1.39968 1.71386 2.50696 1.71771L10.0366 1.7439",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.62109 8.37805L17.4991 0.5",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.499 5.47561V0.5H12.5234",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNavigateToPageIcon;
